/* SORAI STUDIOS — sitewide premium interactions (homepage + shared) */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Tag homepage sections for scroll-reveal
    var targets = document.querySelectorAll(
      '.sorai-catgrid, .sorai-text-band-section, .sorai-product-strip-section, ' +
      '.sorai-editorial-split-section .s-editorial__copy, .sorai-editorial-split-section .s-editorial__img, ' +
      '.sorai-email-signup-section, .sorai-catgrid__tile'
    );
    var nodes = [];
    targets.forEach(function (n) { n.classList.add('sorai-reveal-h'); nodes.push(n); });

    if (!('IntersectionObserver' in window) || !nodes.length) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    nodes.forEach(function (n) { obs.observe(n); });

    // Also drive the lifestyle image-band drift (needs is-in to start animation)
    document.querySelectorAll('.s-imgband').forEach(function (n) {
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); o.unobserve(e.target); } });
      }, { threshold: 0.15 });
      o.observe(n);
    });
  });
})();
